import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminLsaTeamAccounts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/lsa/team_accounts/index.vue')
    createVueApp(IndexPage, { props })
  }
}
